
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { getFullName } from "@/cms-services/helpers";
import { FolderDataSource } from "@/data/Tree/FolderDataSource";
@Component
export default class Home extends Vue {
  dataSource: ListDataSource = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 10,
    },
    className: "order",
  });
  profileDataSource: ListDataSource = new ListDataSource({
    className: "userProfile",
    config: {
      pageIndex: 1,
      pageSize: 100,
    },
  });
  folderDataSource: FolderDataSource = new FolderDataSource({
    className: "OrderFolder",
    rootFolder: "mainFolder",
  });
  $message: any;

  getUserFullName(item) {
    return `${item?.lastName} ${item?.firstName}`;
  }

  createItemModel: any = {
    profileId: null,
  };

  async downloadExcel() {
    try {
      await this.dataSource.downloadExcel("Заказы");
    } catch (error) {
      this.$message((error as any)?.response?.data, "error");
    }
  }

  createItemActions = {
    getProfiles: () => {
      return this.profileDataSource.items;
    },
  };
  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Заказы",
        disabled: true,
      },
    ];
  }

  createItemFields: any = [
    {
      editor: "enum",
      attrs: {
        label: "Пользователь",
        outlined: true,
      },
      name: "profileId",
      config: {
        getItems: "getProfiles",
        labelKeyName: "fullName",
        valueKeyName: "id",
        type: "select",
      },
      validations: [
        {
          validator: "required",
          value: true,
          errorMessage: "Пожалуйста выберите пользователя",
        },
      ],
    },
  ];

  customHeaders: any = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Дата создания",
      value: "createDate",
      sortable: true,
    },
    {
      text: "Пользователь",
      value: "profile",
      sortable: true,
    },
    {
      text: "Сумма закза",
      value: "orderSum",
      sortable: true,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];
  loaded: boolean = false;

  async created() {
    await this.profileDataSource.get();
    this.loaded = true;
  }
}
